import type { Platform, SyncSection } from "../types/edit-connector-wizard"

export const WIZARD_CONSTANTS = {
  TOTAL_STEPS: 3,
}

export const DEFAULT_PLATFORMS: Platform[] = [
  {
    id: "hubspot",
    name: "HubSpot",
    icon: "🟠",
    color: "#ff7a59",
    connected: false,
    connecting: false,
    sync_direction: "bidirectional",
  },
  {
    id: "salesforce",
    name: "Salesforce",
    icon: "🔵",
    color: "#00a1e0",
    connected: false,
    connecting: false,
    sync_direction: "bidirectional",
  },
]

export const DEFAULT_SYNC_SECTIONS: SyncSection[] = [
  {
    id: "hubspot-sync",
    title: "Hubspot sync config",
    expanded: true,
    rules: [
      {
        id: "hs-contact-create",
        sourceAction: `A contact is created`,
        targetAction: `Create the lead`,
        enabled: true,
        sourceIcon: "hubspot",
        targetIcon: "salesforce",
      },
      {
        id: "hs-contact-update",
        sourceAction: `A contact is updated`,
        targetAction: `Update the lead`,
        enabled: true,
        sourceIcon: "hubspot",
        targetIcon: "salesforce",
      },
      {
        id: "hs-contact-delete",
        sourceAction: `A contact is deleted`,
        targetAction: `Delete the lead`,
        enabled: true,
        sourceIcon: "hubspot",
        targetIcon: "salesforce",
      },
    ],
  },
  {
    id: "salesforce-sync",
    title: "Salesforce sync config",
    expanded: true,
    rules: [
      {
        id: "sf-lead-create",
        sourceAction: `A lead is created`,
        targetAction: `Create the contact`,
        enabled: true,
        sourceIcon: "salesforce",
        targetIcon: "hubspot",
      },
      {
        id: "sf-lead-update",
        sourceAction: `A lead is updated`,
        targetAction: `Update the contact`,
        enabled: true,
        sourceIcon: "salesforce",
        targetIcon: "hubspot",
      },
      {
        id: "sf-lead-delete",
        sourceAction: `A lead is deleted`,
        targetAction: `Delete the contact`,
        enabled: true,
        sourceIcon: "salesforce",
        targetIcon: "hubspot",
      },
    ],
  },
]
